// extracted by mini-css-extract-plugin
module.exports = {"ExpandTableWrapper":"ExpandTable_ExpandTableWrapper__31VBj","expand-table":"ExpandTable_expand-table__3gQLt","ant-table-thead":"ExpandTable_ant-table-thead__lLmM9"};